import React from 'react'
import styled from 'styled-components'

import CurrencySelect from '../CurrencySelect'
import DecimalInput from '../DecimalInput'
import Field, { Label } from '../Field'
import CurrencyInputNew, { TCurrencyInputNew } from './CurrencyInputNew'

const Wrapper = styled.div``

const Inner = styled.div`
  display: flex;
`

export interface TCurrencyInput extends TCurrencyInputNew {
  name?: string
  label?: string
  small?: boolean
  validate?: (val: any, allValues?: any) => any
  allowZeroValue?: boolean
  v2?: boolean
  required?: boolean
  disableCurrency?: boolean
}
const CurrencyInput = (props: TCurrencyInput): React.ReactElement => {
  const {
    name,
    label,
    small,
    validate,
    allowZeroValue = false,
    v2,
    disableCurrency,
    ...rest
  } = props

  if (v2) {
    return <CurrencyInputNew {...props} />
  }

  return (
    <Wrapper>
      {label && (
        <div>
          <Label {...rest}>{label}</Label>
        </div>
      )}
      <Inner>
        <div style={{ width: '90px' }} className="mr-1">
          <Field
            name={name ? `${name}.currency` : 'currency'}
            onFocus={rest.onFocus as (e?: React.FocusEvent<any>) => void}
            {...rest}
          >
            <CurrencySelect
              small={small}
              disabled={disableCurrency}
              isDisabled={disableCurrency}
            />
          </Field>
        </div>

        <div className="" style={{ width: '100px' }}>
          <Field
            name={name ? `${name}.value` : 'value'}
            validate={validate}
            {...rest}
          >
            <DecimalInput />
            {/* <NumberInput
              mustBePositive
              min={0}
              max={1000000}
              autofocus
              hideButtons
              small={small}
              allowZeroValue={allowZeroValue}
              block
              noMargin
            /> */}
          </Field>
        </div>
      </Inner>
    </Wrapper>
  )
}

export default CurrencyInput
